import React from "react"
import Link from "components/atoms/Link/Link"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router-dom"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"

const ProfileKnowledgeBaseView = () => {
  const { t } = useTranslation(["panel", "common"])

  return (
    <>
      <NavigationWrapper>
        <Link $type="secondary" to="/panel/profile/knowledge-base" end>
          {t("profile.knowledge-base.navigation.faqs")}
        </Link>
        <Link $type="secondary" to="/panel/profile/knowledge-base/scrapings">
          {t("profile.knowledge-base.navigation.scrapings")}
        </Link>
      </NavigationWrapper>
      <Outlet />
    </>
  )
}

export default ProfileKnowledgeBaseView

const NavigationWrapper = styled(Box)`
  display: flex;
  grid-gap: ${({ theme }) => theme.space.XS};
  margin-bottom: ${({ theme }) => theme.space.S};
`
